import { Appointment as AppointmentAPI } from 'patient-api-lib'
import { Appointment } from '../../models/types'
import { createDateFromObject } from '../../util/date'

export const adaptAppointmentResponse = (
  appointment: AppointmentAPI
): Appointment => {
  const appointmentStartTime = appointment.getStartTime()
  const appointmentEndTime = appointment.getEndTime()

  const reducedPrice = appointment
    .getAppointmentPrice()
    ?.getReducedPrice()
    ?.getPrice()
    ?.getUnits()
  const reducedOldPrice = appointment
    .getAppointmentPrice()
    ?.getReducedPrice()
    ?.getOldPrice()
    ?.getUnits()

  const standardPrice =
    appointment
      .getAppointmentPrice()
      ?.getStandardPrice()
      ?.getPrice()
      ?.getUnits() ?? reducedOldPrice

  const startTime = createDateFromObject(
    appointmentStartTime?.toObject()
  ).toISO()
  const endTime = createDateFromObject(appointmentEndTime?.toObject()).toISO()

  return {
    id: appointment.getId(),
    clinicId: appointment.getClinicId(),
    treatmentId: appointment.getTreatmentId(),
    careGiverId: appointment?.getPrimaryCaregiverId()?.getValue(),
    price: {
      standardPrice,
      reducedPrice,
    },
    startTime,
    endTime,
    careGiverName: appointment.getPrimaryCaregiver()?.getName()?.getValue(),
  }
}
